<template>
    <div class="form-group row" style="margin-bottom:0">
        <label class="col-lg-4 col-md-3 control-label" style="color:#22690b;">Delivery Boy</label>
        <div v-if="!editable" class="col-lg-6 col-md-9" style="padding-top:7px">
            <strong v-if="item.deliveryboy">{{ item.deliveryboy.name }}</strong>
            <span v-else style="color:#999">Not assigned</span>
        </div>
        <div v-if="editable" class="col-lg-4 col-md-6">
            <select v-model="deliveryboyid" class="form-control form-cascade-control input-small">
                <option :value="0">--- Not Assigned ---</option>
                <option v-for="emp in employees" :key="emp.id" :value="emp.id">{{ emp.name }}</option>
            </select>
        </div>
        <div v-if="editable" class="col-lg-2 col-md-3">
            <button type="button" class="btn btn-success" :disabled="saving || !changed" @click="save()">
                {{ saving ? 'Saving...' : 'Change' }}
            </button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
// Change the delivery boy of an order from its conversation. Assign To,
// status and the estimated delivery time are set in the conversation steps.
export default {
    // editable=false shows only the name (e.g. delivered / rejected orders)
    props: ['item', 'editable'],
    data() {
        return {
            saving: false,
            deliveryboyid: this.item.deliveryboyid || 0
        }
    },
    computed: {
        ...mapGetters(['employees']),
        changed() {
            return Number(this.deliveryboyid) !== Number(this.item.deliveryboyid || 0)
        }
    },
    methods: {
        save() {
            this.saving = true
            this.$http.post('api/vsdigi/leads/orders/delivery', { id: this.item.id, deliveryboyid: this.deliveryboyid })
                .then(() => {
                    this.$notify({ text: 'Delivery boy updated', type: 'success' })
                    this.$emit('saved')
                })
                .catch((err) => {
                    console.log(err)
                    this.$notify({ text: err.response?.data?.message || 'Unable to update delivery boy', type: 'error' })
                })
                .finally(() => {
                    this.saving = false
                })
        }
    }
}
</script>
